<template>
  <div :class="['lr2-modal', {'hide': !show}]">
    <div class="lr-box">
      <div class="lr-header d-flex align-center justify-space-between">
        <div class="lr-title">Flight Details</div>
        <i class="far fa-times-circle fa-2x" @click="close"></i>
      </div>

      <div class="fl-tabs d-flex" v-if="isReturning && leg1Flight.length > 1 && leg2Flight.length > 1">
        <div :class="['fl-tab', {active: active === 'leg1'}]" @click="active = 'leg1'">
          <img :src="leg1Flight[0].logo" />
          <span>
            {{ leg1Flight[0].origin.CityName }}
            -
            {{ leg1Flight[leg1Flight.length - 1].destination.CityName }}
          </span>
        </div>
        <div :class="['fl-tab', {active: active === 'leg2'}]" @click="active = 'leg2'">
          <img :src="leg2Flight[0].logo" />
          <span>
            {{ leg2Flight[0].origin.CityName }}
            -
            {{ leg2Flight[leg2Flight.length - 1].destination.CityName }}
          </span>
        </div>
      </div>

      <div v-for="(flight, i) in leg1Flight" v-if="active === 'leg1'">
        <div class="flight-of">Flight {{ i + 1 }} of {{ leg1Flight.length }}</div>
        <div class="flight-box">
          <div class="fl-no d-flex align-center">
            <img :src="flight.logo" />
            <span>{{ `${flight.airline.name} ${flight.airline.code}${flight.flightNo}` }}</span>
          </div>
  
          <div class="d-flex align-stretch fl-data">
            <div class="time-line d-flex flex-column">
              <div class="tl-dot"></div>
              <div class="tl-line"></div>
            </div>
  
            <div class="flight-text">
              <div class="fl-city">{{ flight.origin.CityName }}</div>
              <div class="fl-airport">{{ `${flight.origin.AirportName} (${flight.origin.AirportCode})` }}</div>
              <div class="fl-airport" v-if="flight.origin.Terminal">Terminal {{ flight.origin.Terminal }}</div>
              <div class="travel-time">Travel Time: {{ timeDiff(flight.origin.DateTime, flight.destination.DateTime) }}</div>
            </div>
  
            <div class="flight-date">
              <div class="fl-time">{{ timeFormat(flight.origin.DateTime) }}</div>
              <div class="fl-day">{{ dateFormat(flight.origin.DateTime) }}</div>
            </div>
          </div>
  
          <div class="d-flex align-stretch fl-data">
            <div class="time-line d-flex flex-column">
              <div class="tl-dot"></div>
              <div class="tl-line"></div>
            </div>
  
            <div class="flight-text">
              <div class="fl-city">{{ flight.destination.CityName }}</div>
              <div class="fl-airport">{{ `${flight.destination.AirportName} (${flight.destination.AirportCode})` }}</div>
              <div class="fl-airport" v-if="flight.destination.Terminal && flight.destination.Terminal !== 0">Terminal {{ flight.destination.Terminal }}</div>
            </div>
  
            <div class="flight-date">
              <div class="fl-time">{{ timeFormat(flight.destination.DateTime) }}</div>
              <div class="fl-day">{{ dateFormat(flight.destination.DateTime) }}</div>
            </div>
          </div>
        </div>

        <div class="layover-box" v-if="i < leg1Flight.length - 1">
          <i class="far fa-clock"></i>
          <b>
            {{ timeDiff(flight.destination.DateTime, leg1Flight[i + 1].origin.DateTime) }} 
            layover in 
            {{ leg1Flight[i + 1].origin.CityName }}
          </b>
        </div>
      </div>

      <div v-for="(flight, i) in leg2Flight" v-if="active === 'leg2'">
        <div class="flight-of">Flight {{ i + 1 }} of {{ leg2Flight.length }}</div>
        <div class="flight-box">
          <div class="fl-no d-flex align-center">
            <img :src="flight.logo" />
            <span>{{ `${flight.airline.name} ${flight.airline.code}${flight.flightNo}` }}</span>
          </div>
  
          <div class="d-flex align-stretch fl-data">
            <div class="time-line d-flex flex-column">
              <div class="tl-dot"></div>
              <div class="tl-line"></div>
            </div>
  
            <div class="flight-text">
              <div class="fl-city">{{ flight.origin.CityName }}</div>
              <div class="fl-airport">{{ `${flight.origin.AirportName} (${flight.origin.AirportCode})` }}</div>
              <div class="fl-airport" v-if="flight.origin.Terminal">Terminal {{ flight.origin.Terminal }}</div>
              <div class="travel-time">Travel Time: {{ timeDiff(flight.origin.DateTime, flight.destination.DateTime) }}</div>
            </div>
  
            <div class="flight-date">
              <div class="fl-time">{{ timeFormat(flight.origin.DateTime) }}</div>
              <div class="fl-day">{{ dateFormat(flight.origin.DateTime) }}</div>
            </div>
          </div>
  
          <div class="d-flex align-stretch fl-data">
            <div class="time-line d-flex flex-column">
              <div class="tl-dot"></div>
              <div class="tl-line"></div>
            </div>
  
            <div class="flight-text">
              <div class="fl-city">{{ flight.destination.CityName }}</div>
              <div class="fl-airport">{{ `${flight.destination.AirportName} (${flight.destination.AirportCode})` }}</div>
              <div class="fl-airport" v-if="flight.destination.Terminal && flight.destination.Terminal !== 0">Terminal {{ flight.destination.Terminal }}</div>
            </div>
  
            <div class="flight-date">
              <div class="fl-time">{{ timeFormat(flight.destination.DateTime) }}</div>
              <div class="fl-day">{{ dateFormat(flight.destination.DateTime) }}</div>
            </div>
          </div>
        </div>

        <div class="layover-box" v-if="i < leg2Flight.length - 1">
          <i class="far fa-clock"></i>
          <b>
            {{ timeDiff(flight.destination.DateTime, leg2Flight[i + 1].origin.DateTime) }} 
            layover in 
            {{ leg2Flight[i + 1].origin.CityName }}
          </b>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
export default {
  name: 'flight-details-modal',
  data () {
    return {
      show: false,
      active: 'leg1'
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    selected () { return this.booking.selected },
    settings () { return this.booking.settings },
    leg1Flight () { return this.selected.leg1.flight },
    leg2Flight () {
      return this.settings.customFlight ? this.selected.leg2.flight : this.selected.leg1.returnFlight
    }
  },
  methods: {
    dateFormat (x, isFormated = false, eta = null) {
      if (!x) return ''
      let format = isFormated ? 'MM/DD/YYYY hh:mmA' : 'YYYY-MM-DD HH:mm'
      let date = moment(x, format)
      if (eta) date.add(eta, 'minutes')
      return date.format('ddd, MMM DD')
    },
    timeFormat (x, isFormated = false, eta = null) {
      if (!x) return ''
      let format = isFormated ? 'MM/DD/YYYY hh:mmA' : 'YYYY-MM-DD HH:mm'
      let date = moment(x, format)
      if (eta) date.add(eta, 'minutes')
      return date.format('h:mma')
    },
    timeDiff (x, y) {
      if (!x || !y) return ''
      x = moment(x, 'YYYY-MM-DD HH:mm')
      y = moment(y, 'YYYY-MM-DD HH:mm')
      let duration = moment.duration(y.diff(x))
      let days = duration._data.days ? `${duration._data.days}d ` : ''
      return `${days}${duration._data.hours}h ${duration._data.minutes}m`
    },
    showModal (leg) {
      this.show = true
      this.active = leg
    },
    close () {
      this.show = false
    }
  },
  watch: {
    show (val) {
      document.getElementsByTagName('html')[0].style.overflow = val ? 'hidden' : ''
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.lr-box {
  padding: 20px;
  width: 100%;
  max-width: 560px;
  text-align: left;
}
.lr-header{
  margin-bottom: 20px;
}
.lr-title{
  font-size: 21px;
  font-weight: 600;
}
.fa-times-circle{
  color: #f22a2a;
  cursor: pointer;
}

.fl-tabs{
  margin-bottom: 20px;
}
.fl-tab{
  font-size: 12px;
  letter-spacing: .7px;
  word-spacing: 2px;
  border-radius: 4px;
  padding: 3px 8px;
  border: 1px solid #ddd;
  background: #fcfcfc;
  margin-right: 15px;
  cursor: pointer;

  &.active{
    border: 1px solid #999;
    background: #f3f3f3;
  }
  img{
    width: 30px;
    margin-right: 5px;
  }
}

.flight-of{
  font-size: 13px;
  letter-spacing: .7px;
  color: #868686;
  margin-bottom: 5px;
}
.flight-box{
  background: #eaf7ff;
  padding: 15px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
}
.fl-no{
  margin-bottom: 10px;
  img {
    height: 30px;
    width: 30px;
    margin-right: 10px;
  }
  span{
    font-weight: 600;
    letter-spacing: .5px;
    font-size: 15px;
  }
}
.time-line{
  padding-right: 8px;
}
.tl-dot{
  background: #2689df;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  position: relative;
  top: 5px;
}
.tl-line{
  background: #a9ceee;
  width: 3px;
  height: calc(100% - 15px);
  position: relative;
  top: 8px;
  left: 2px;
}
.fl-data:last-child .tl-line{
  display: none;
}

.flight-text, .flight-date{
  letter-spacing: .5px;
  line-height: 1;
}
.flight-text{
  width: 100%;
}
.fl-city, .fl-time{
  font-size: 18px;
  letter-spacing: .6px;
  margin-bottom: 5px;
  font-weight: 600;
}
.fl-airport, .fl-day{
  font-size: 13px;
  margin-bottom: 4px;
  color: #6b7b8a;
}
.travel-time{
  font-size: 13px;
  margin: 15px 0;
  color: #929ca6;
  letter-spacing: .7px;
}

.flight-date{
  text-align: right;
  width: 100px;
}

.layover-box{
  background: #f1f1f1;
  padding: 15px 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  letter-spacing: .7px;

  b{
    font-size: 14px;
    margin-left: 5px;
    vertical-align: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// FlightDetailsModal.vue?704d9457